'use strict';

// shared by the server and the web client

// the markup a notification's log may carry; Vybit's review vybit adds a REVIEW button's attributes
const LOG_TAGS = ['b', 'i', 'em', 'strong', 'a', 'br', 'p'];
const REVIEW_LINK_ATTRIBUTES = ['class', 'data-reviewkey'];

const HTML_ESCAPES = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
// an http(s) url, minus trailing punctuation that usually ends the sentence around it
const URL_PATTERN = /(https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)\]}])/i;

function escapeHtml(text){
    return text.replace(/[&<>"']/g, function(c){ return HTML_ESCAPES[c]; });
}

// plain text to html: escape it, link its urls and keep its line breaks. linkAttrs is extra markup
// for each link, such as ' target="_blank"'. split with a capture group puts the urls at the odd indexes
function textToHtml(text, linkAttrs = ''){
    return text.split(URL_PATTERN).map(function(part, i){
        const escaped = escapeHtml(part);
        return i % 2 ? '<a href="' + escaped + '"' + linkAttrs + '>' + escaped + '</a>' : escaped;
    }).join('').replace(/\r?\n/g, '<br>');
}

// browsers skip whitespace and control characters inside a scheme, so "java\tscript:" still runs
const UNSAFE_SCHEME = /^(javascript|data|vbscript):/i;

// the url, trimmed, or '' when it would run script. Other schemes stay: customers link into their
// own apps, such as crestron-app://
function safeUrl(url){
    if(typeof url !== 'string') return '';
    const trimmed = url.trim();
    return UNSAFE_SCHEME.test(trimmed.replace(/[\s\u0000-\u001f\u007f]+/g, '')) ? '' : trimmed;
}

// text with anything tag-shaped removed, including a tag left open at the end
function stripTags(text){
    return text.replace(/<[^>]*>?/g, '');
}

const ELLIPSIS = '\u2026';

// html cut to at most maxLength characters, ellipsis included, never ending inside a tag, an entity
// or a surrogate pair. An <a> or <b> left open closes itself when the html is rendered
function truncateHtml(html, maxLength){
    if(html.length <= maxLength) return html;
    let cut = html.slice(0, Math.max(0, maxLength - ELLIPSIS.length));
    if(/[\ud800-\udbff]$/.test(cut)) cut = cut.slice(0, -1);
    const tagStart = cut.lastIndexOf('<');
    if(tagStart > cut.lastIndexOf('>')) cut = cut.slice(0, tagStart);
    const entity = cut.match(/&#?[a-z0-9]*$/i);
    if(entity) cut = cut.slice(0, entity.index);
    return cut.trimEnd() + ELLIPSIS;
}

module.exports = {LOG_TAGS, REVIEW_LINK_ATTRIBUTES, escapeHtml, textToHtml, truncateHtml, safeUrl, stripTags};
